var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "passwordBox animated fadeInDown" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col" }, [
          _c("div", { staticClass: "ibox-content sombra" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col text-center" }, [
                _c("img", {
                  staticClass: "img-fluid",
                  attrs: { src: _vm.logo, alt: "Logo" },
                }),
              ]),
            ]),
            _vm._v(" "),
            !_vm.enviado
              ? _c(
                  "form",
                  {
                    on: {
                      submit: function ($event) {
                        $event.preventDefault()
                        return _vm.envia_codigo.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", [
                            _vm._v(
                              "Autenticacion de 2 Factores. Seleccione Metodo"
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "input-group" }, [
                            _vm._m(0),
                            _vm._v(" "),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.tipo,
                                    expression: "tipo",
                                  },
                                ],
                                staticClass: "custom-select",
                                on: {
                                  change: function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.tipo = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  },
                                },
                              },
                              [
                                _c(
                                  "option",
                                  { attrs: { disabled: "", value: "" } },
                                  [_vm._v("Seleccione")]
                                ),
                                _vm._v(" "),
                                _vm.canal_2fa_email == 1
                                  ? _c(
                                      "option",
                                      { attrs: { value: "Email" } },
                                      [
                                        _vm._v(
                                          "\n                                                Correo: " +
                                            _vm._s(_vm.email) +
                                            "\n                                            "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.canal_2fa_telefono == 1
                                  ? _c(
                                      "option",
                                      { attrs: { value: "Telefono" } },
                                      [
                                        _vm._v(
                                          "\n                                                Telefono: " +
                                            _vm._s(_vm.telefono) +
                                            "\n                                            "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                          ]),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary",
                            attrs: { disabled: _vm.disable },
                          },
                          [_vm._v("Enviar")]
                        ),
                      ]),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.enviado
              ? _c(
                  "form",
                  {
                    on: {
                      submit: function ($event) {
                        $event.preventDefault()
                        return _vm.verifica_codigo.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", [_vm._v("ingresa el Codigo")]),
                          _vm._v(" "),
                          _c("div", { staticClass: "input-group" }, [
                            _vm._m(1),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.codigo,
                                  expression: "codigo",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: { placeholder: "Codigo", type: "text" },
                              domProps: { value: _vm.codigo },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.codigo = $event.target.value
                                },
                              },
                            }),
                          ]),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary",
                            attrs: { type: "submit" },
                          },
                          [_vm._v("Verificar")]
                        ),
                        _vm._v(" "),
                        !_vm.volver_a_enviar
                          ? _c("div", [
                              _vm._v(
                                "Volver a enviar en " +
                                  _vm._s(_vm.minutos) +
                                  ":" +
                                  _vm._s(
                                    _vm.segundos < 10
                                      ? "0" + _vm.segundos
                                      : _vm.segundos
                                  )
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.volver_a_enviar
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-primary",
                                on: { click: _vm.resend },
                              },
                              [_vm._v("Volver a enviar")]
                            )
                          : _vm._e(),
                      ]),
                    ]),
                  ]
                )
              : _vm._e(),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-addon" }, [
        _c("i", { staticClass: "fal fa-envelope" }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-addon" }, [
        _c("i", { staticClass: "fal fa-envelope" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }